import { render, staticRenderFns } from "./deleteModel.vue?vue&type=template&id=29e28acd"
import script from "./deleteModel.vue?vue&type=script&lang=js"
export * from "./deleteModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports